import "./index.0.css";
import { capitalize } from "lodash-es";
import { isMobile } from "../../../../lib/utils/browser/isMobile";
const __script_base__ = {
  name: 'WRow',
  props: {
    className: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    },
    gap: {
      type: String,
      default: 'default'
    },
    // compact / none
    heightConfig: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100px'
    },
    gapCustom: {
      type: String,
      default: '16px'
    }
  },
  computed: {
    finalClassName() {
      const ans = [this.gap === 'default' ? '' : `with${capitalize(this.gap)}Gap`,
      // withCompactGap withNoneGap
      this.className, isMobile() && 'isMobile'];
      return ans.filter(Boolean).join(' ');
    },
    finalCss() {
      const gapCss = this.gap === 'custom' && `gap:${this.gapCustom}`;
      const heightCss = this.heightConfig === 'fillAvailable' && 'height:-webkit-fill-available;flex-grow:1';
      const customHeightCss = this.heightConfig === 'fixed' && `height:${this.height}`;
      return [heightCss, customHeightCss, gapCss, this.css].filter(Boolean).join(';');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "w-row",
    class: _vm.finalClassName,
    style: _vm.finalCss
  }, [_vm._t("default", function () {
    return [_c("div", {
      staticClass: "w-row-invalid"
    }, [_vm._v("\n      无效列组件，请删除\n    ")])];
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Row/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);